import * as THREE from 'three';

const FORWARD = new THREE.Vector3(0, 0, 1);
const normal = new THREE.Vector3();

/** Unit square outline in the XY plane, centered at the origin. */
export function createFaceOutlineGeometry(): THREE.BufferGeometry {
  return new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(-0.5, -0.5, 0),
    new THREE.Vector3(0.5, -0.5, 0),
    new THREE.Vector3(0.5, -0.5, 0),
    new THREE.Vector3(0.5, 0.5, 0),
    new THREE.Vector3(0.5, 0.5, 0),
    new THREE.Vector3(-0.5, 0.5, 0),
    new THREE.Vector3(-0.5, 0.5, 0),
    new THREE.Vector3(-0.5, -0.5, 0),
  ]);
}

export function orientFaceOutline(
  outline: THREE.Object3D,
  nx: number,
  ny: number,
  nz: number,
): void {
  normal.set(nx, ny, nz);
  outline.quaternion.setFromUnitVectors(FORWARD, normal);
}
